import { List } from '../List'
import { CommonWork } from '../CommonWork'

export class StudentGuideParent extends List {
  constructor(obj) {
    super(StudentGuide, obj)
  }
}

export class StudentGuide {
  constructor(obj) {
    this.id = obj?.id || null
    this.commonWork = new CommonWork(obj?.commonWork || null)
    this.studentName = obj?.studentName || null
    this.reportName = obj?.reportName || null
    this.conferenceName = obj?.conferenceName || null
    this.articleTitle = obj?.articleTitle || null
    this.conferenceDate = obj?.conferenceDate || null
    this.guideType = obj?.guideType || null
    this.link = obj?.link || null
    this.magazine = obj?.magazine || null
    this.magazineName = obj?.magazineName || null
    this.conferenceMaterial = obj?.conferenceMaterial || Boolean(obj?.magazineName) || false
    this.curatorPeriod = obj?.curatorPeriod || null
  }

  getForAPI() {
    return {
      id: this.id,
      commonWork: this.commonWork.getForAPI(),
      studentName: this.studentName,
      reportName: this.reportName,
      conferenceName: this.conferenceName,
      articleTitle: this.articleTitle,
      conferenceDate: this.conferenceDate,
      guideType: this.guideType,
      link: this.link,
      magazine: this.magazine,
      magazineName: this.magazineName,
      conferenceMaterial: this.conferenceMaterial,
      curatorPeriod: this.curatorPeriod
    }
  }
}
